{
  "verified": "Zweryfikowano",
  "iv_status": {
    "verified": "Zweryfikowano",
    "pending": "W toku",
    "attention": "Uwaga"
  },
  "zoom_in": "Powiększenie",
  "zoom_out": "Zoom Out",
  "rotate": "Obrót",
  "close": "Zamknij",
  "esc_to_close": "Naciśnij ESC, aby zamknąć",
  "play": "Grać",
  "pause": "Pauza",
  "mute": "Wyciszenie",
  "unmute": "Wyłącz wyciszenie",
  "enter_full_screen": "Wejdź na pełny ekran",
  "exit_full_screen": "Wyjście na pełnym ekranie",
  "video_not_supported": "Twoja przeglądarka nie obsługuje tagu wideo.",
  "skip_forward": "Przejdź do przodu",
  "skip_backward": "Pomiń do tyłu",
  "loading": "Ładowanie",
  "loading_video": "Ładowanie wideo...",
  "loading_data_description": "Poczekaj, aż załadujemy Twoje dane. Nie potrwa to długo.",
  "no_results": "Brak wyników",
  "nothing_found": "Nic nie znaleziono",
  "save_changes": "Zapisz zmiany",
  "saved_exclamation": "Ocalony!",
  "saving": "Oszczędzanie",
  "validating": "Sprawdzanie poprawności",
  "error": "Błąd",
  "optional": "Opcjonalnie",
  "search_property": "Wyszukiwanie nieruchomości",
  "reset_search": "Zresetuj wyszukiwanie",
  "no_items_to_show": "Brak elementów do pokazania",
  "showing_range_of_total_items": "Wyświetlanie {{range}} z {{total}} elementów",
  "rows_per_page": "Wiersze na stronę",
  "page_of_pages": "Strona {{page}} z {{pages}}",
  "go_to_first_page": "Przejdź do pierwszej strony",
  "go_to_previous_page": "Przejdź do poprzedniej strony",
  "go_to_next_page": "Przejdź do następnej strony",
  "go_to_last_page": "Przejdź do ostatniej strony",
  "sort_in_asc": "Sortuj w porządku rosnącym",
  "sort_in_desc": "Sortuj w kolejności malejącej",
  "sort_a_z": "Sortuj A → Z",
  "sort_z_a": "Sortuj Z → A",
  "clear_sorting": "Wyczyść sortowanie",
  "reach_us_at_email": "Wsparcie można uzyskać pod adresem support@chekin.com",
  "please_wait": "Proszę czekać",
  "feature_coming_soon": "Już wkrótce",
  "feature_coming_soon_description": "Ta funkcja jest obecnie w fazie rozwoju i będzie dostępna wkrótce. Bądź na bieżąco z aktualizacjami!",
  "download_all": "Pobierz wszystko",
  "entry_forms": "Formularze zgłoszeniowe",
  "tutorial": "Samouczek",
  "liveness_video": "Wideo Liveness",
  "beta": "Beta",
  "reviews": "Recenzje",
  "learn_more": "Dowiedz się więcej",
  "this_cannot_be_reverted": "Nie można tego cofnąć",
  "delete": "Usuń",
  "cancel": "Anuluj",
  "you_have_made_changes": "Dokonałeś zmian",
  "would_you_like_to_save_them": "Czy chciałbyś je uratować?",
  "save": "Zapisz",
  "dont_save": "Nie oszczędzaj",
  "copied_exclamation": "Skopiowane!",
  "search_placeholder": "Szukaj...",
  "type_to_search": "Wpisz, aby wyszukać...",
  "loading_more": "Ładowanie...",
  "no_options": "Brak opcji",
  "select_option": "Wybierz opcję",
  "clear_all": "Wyczyść wszystko",
  "remove_item": "Usuń {{label}}",
  "upload_file": "Prześlij plik",
  "download_attachment": "Załącznik do pobrania",
  "remove_file": "Usuń plik",
  "open_calendar": "Kalendarz otwarty",
  "clear_dates": "Jasne daty",
  "select_dates": "Wybierz daty",
  "pick_date_range": "Wybierz zakres dat",
  "from": "Od",
  "to": "Do",
  "pick_month": "Wybierz miesiąc",
  "pick_date": "Wybierz datę",
  "month": "Miesiąc",
  "day": "Dzień",
  "year": "Rok",
  "done": "Gotowe",
  "wrong_period_of_dates": "Wybrany okres jest nieprawidłowy",
  "date_range_max_days_error_one": "Zakres nie może przekraczać {{count}} dni",
  "date_range_max_days_error_other": "Zakres nie może przekraczać {{count}} dni",
  "date_range_min_days_error_one": "Zakres musi wynosić co najmniej {{count}} dni",
  "date_range_min_days_error_other": "Zakres musi wynosić co najmniej {{count}} dni",
  "past_dates": "Data nie może być wcześniejsza niż {{minDate}}",
  "future_dates": "Data nie może być późniejsza niż {{maxDate}}.",
  "signature_placeholder_text": "Podpisz się w tym polu.<br/> Użyj palca.<br/> Stuknij, aby rozpocząć.",
  "open_devices_camera": "Otwórz kamerę urządzenia",
  "place_document_inside_frame": "Umieść dokument w ramce",
  "close_other_application_that_may_be_using_your_camera": "Zamknij inne aplikacje, które mogą korzystać z kamery",
  "if_you_use_external_camera_disconnect_and_reconnect": "Jeśli używasz kamery zewnętrznej, odłącz ją i podłącz ponownie",
  "close_the_browser_re_open_it": "Zamknij przeglądarkę i otwórz ją ponownie",
  "camera_errors": {
    "experiencing_camera_issues": "Problemy z kamerą?",
    "chekin_cant_use_your_camera": "Chekin nie może używać kamery",
    "please_try_a_different_browser": "Kamera nie działa w tej przeglądarce. Spróbuj otworzyć łącze w innej przeglądarce.",
    "permissions_denied": "Odmowa zezwolenia",
    "camera_permissions_denied": "Kamera nie otwiera się? Upewnij się, że zezwolono przeglądarce na korzystanie z kamery.",
    "no_camera_device_found": "Nie znaleziono urządzenia kamery. Podłącz kamerę.",
    "constraints_camera_error": "Ograniczenia nie mogą być spełnione przez dostępne urządzenia.",
    "safari_camera_error": "Safari nie mogła spełnić wymagań kamery",
    "try_chrome_or_firefox": "Wypróbuj przeglądarkę Chrome lub Firefox"
  },
  "clear": "Wyczyść",
  "show_less": "Pokaż mniej",
  "show_more": "Pokaż więcej",
  "tap_here_to_sign": "Kliknij tutaj, aby podpisać",
  "click_here_to_sign": "Kliknij tutaj, aby podpisać",
  "prefix": "Prefiks",
  "prefix_required": "Prefiks jest wymagany",
  "reset": "Reset",
  "show_password": "Pokaż hasło",
  "hide_password": "Ukryj hasło",
  "increment": "Przyrost",
  "decrement": "Spadek",
  "create_option": "Utwórz \"{{input}}\"",
  "year_out_of_range": "Rok musi zawierać się w przedziale od {{min}} do {{max}}.",
  "clear_date": "Jasna data",
  "select_date": "Wybierz datę",
  "draw_signature_here": "Proszę złożyć tutaj swój podpis",
  "signature_hint": "Użyj myszki lub palca",
  "clear_signature": "Wyraźny podpis",
  "draw_signature_here_mobile": "Narysuj swój podpis",
  "signature_hint_mobile": "Użyj palca",
  "camera_access_needed": "Wymagany dostęp do aparatu",
  "camera_access_needed_text": "Zezwól aplikacji na dostęp do aparatu, aby wykonać zdjęcie. Jeśli dostęp jest zablokowany, włącz obsługę aparatu w ustawieniach przeglądarki, a następnie spróbuj ponownie.",
  "dialog": "Okno dialogowe"
}
